module.exports = __webpack_public_path__ + "images/application/badge-email-any@2x-459ff1fd.png";